import { useEffect } from 'react';

import { Modusign36h } from '@app/components/Logos';
import authService from '@app/libs/auth/authService';
import scrubURL from '@app/libs/scrubURL';
import workspaceService from '@app/libs/workspaceService';

import pictoWarning from './errorIcon.svg';

function refreshPage() {
  const { origin } = window.location;
  window.location.href = `${origin}`;
}

function hasChannelIO() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return typeof window.ChannelIO === 'function';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function AppErrorFallback({ error }: { error: any }) {
  let subject = '';
  try {
    subject = authService.getSub() || 'null';
  } catch (e) {
    subject = `error while getting subject: ${e.message}`;
  }

  let workspaceId = '';
  try {
    if (workspaceService.hasWorkspaceId()) {
      workspaceId = workspaceService.getWorkspaceId();
    } else {
      workspaceId = 'null';
    }
  } catch (e) {
    workspaceId = `error occurred while getting workspace id: ${e.message}`;
  }

  let url = '';
  try {
    url = scrubURL(window.location.href);
  } catch (e) {
    url = `error occurred while getting url: ${e.message}`;
  }

  useEffect(() => {
    if (hasChannelIO()) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.ChannelIO?.('setPage', 'unhandledError');
    }

    return () => {
      if (hasChannelIO()) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.ChannelIO?.('resetPage');
      }
    };
  }, []);

  return (
    <div className="Background-Legacy Background--light-gray">
      <div className="Container Container--max-md">
        <div className="Card Card--theme-flat box-4x align-center">
          <div // eslint-disable-line
            className="align-left"
            onClick={refreshPage}
          >
            <Modusign36h style={{ cursor: 'pointer', marginBottom: 12 }} />
          </div>
          <hr className="Line" />
          <img alt="" src={pictoWarning} width="200" />
          <h4>앗, 알 수 없는 오류가 발생했습니다!</h4>
          <p>
            새로고침 후에도 계속 같은 문제가 발생한다면,
            <br />
            고객센터로 문의해주세요.
          </p>
          <section
            style={{
              maxHeight: '200px',
              padding: '24px 18px',
              background: '#FBFBFB',
              overflowY: 'auto',
              textAlign: 'left',
              marginBottom: '36px',
              border: '1px solid #F0F0F0',
            }}
          >
            <h3
              style={{
                fontSize: '13px',
                fontWeight: '500',
                lineHeight: '18px',
                letterSpacing: '-0.04em',
                marginBottom: '6px',
              }}
            >
              오류 내용
            </h3>
            <div>url: {url}</div>
            <div>subject: {subject}</div>
            <div style={{ marginBottom: '8px' }}>workspaceID: {workspaceId}</div>
            {error instanceof Error ? (
              <div>
                <div>error message: {error.message}</div>
                <div>error name: {error.name}</div>
                <div>error stack: {error.stack}</div>
              </div>
            ) : (
              <div>{JSON.stringify(error)}</div>
            )}
          </section>
          <button className="Btn Btn--md" type="button" onClick={refreshPage}>
            홈으로
          </button>
          {hasChannelIO() && (
            <button
              className="Btn Btn--md Btn--primary"
              type="button"
              onClick={() => {
                let message = `url: ${url}\nsubject: ${subject}\nworkspaceID: ${workspaceId}\n`;

                if (error instanceof Error) {
                  message += `error name: ${error.name}\nerror message: ${error.message}\nerror stack: ${error.stack}`;
                } else {
                  message += JSON.stringify(error);
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                window.ChannelIO('openChat', undefined, message);
              }}
            >
              문의하기
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
